import React from 'react';
import Styles from './progress-bar-simple-styles.scss';
import classNames from 'classnames';
var typeColor;
(function (typeColor) {
    typeColor["savings"] = "#89C900";
})(typeColor || (typeColor = {}));
const ProgressBarSimple = ({ percentage = 0, leftText = 'Progress', rightText = 'Completed', backgroundColor = 'green', pointColor = 'green' }) => {
    const setPointColorBacground = () => {
        switch (pointColor) {
            case 'purple':
                return '#695CFF';
            case 'red':
                return '#F04A4A';
            case 'orange':
                return '#F48218';
            case 'blue':
                return '#2AB1EB';
            case 'green':
                return '#65C702';
            case 'savings':
                return '#89C900';
            default:
                return '#2AB1EB';
        }
    };
    return (React.createElement("div", { className: Styles.progressBarSimpleWrap },
        React.createElement("div", { className: classNames([Styles.bar, backgroundColor === 'green' ? Styles.barGreen : Styles.barWhite]) },
            React.createElement("div", { className: classNames([Styles.barInt, backgroundColor === 'green' ? Styles.barIntGreen : Styles.barIntWhite]), style: {
                    width: `${percentage}%`
                } }, pointColor !== 'savings' && (React.createElement("span", { className: Styles['bar-circle'], style: {
                    right: 0,
                    left: percentage === 0 ? '0' : 'unset'
                } },
                React.createElement("span", { className: Styles['bar-circle-int'], style: {
                        backgroundColor: backgroundColor === 'green' ? 'white' : setPointColorBacground()
                    } }))))),
        pointColor !== 'savings' && (React.createElement("div", { className: Styles.texts },
            React.createElement("span", { style: {
                    color: backgroundColor === 'white' ? '#fff' : '#000'
                }, className: Styles['-progress'] }, leftText),
            React.createElement("span", { style: {
                    color: backgroundColor === 'white' ? '#fff' : '#000'
                }, className: Styles['-completed'] }, rightText)))));
};
export default ProgressBarSimple;
